import { TypeColors, variables } from '@bitrise/bitkit';
import { BuildMetrics, BuildStatus, StepStatus } from '@trace/types';

export const STATUS_COLORS: Record<BuildStatus | StepStatus, TypeColors> = {
  Aborted: 'yellow-2',
  Failed: 'red-2',
  Successful: 'green-2',
  failed: 'red-2',
  failed_skippable: 'red-2',
  skipped: 'gray-3',
  skipped_with_runif: 'gray-3',
  success: 'green-2',
};

export const STATUS_COLORS_HEX: Record<BuildStatus | StepStatus, string> = {
  Aborted: variables.colorYellow2,
  Failed: variables.colorRed2,
  Successful: variables.colorGreen2,
  failed: variables.colorRed2,
  failed_skippable: variables.colorRed2,
  skipped: variables.colorGray3,
  skipped_with_runif: variables.colorGray3,
  success: variables.colorGreen2,
};

export const BUILD_METRIC_COLORS: Record<keyof BuildMetrics, TypeColors> = {
  maxTimeAbortManual: 'yellow-2',
  maxTimeAbortRolling: 'yellow-2',
  maxTimeFail: 'red-2',
  maxTimeSuccess: 'green-2',
  maxTimeWait: 'gray-6',
  totalBuilds: 'gray-6',
  totalBuildsAbortedManual: 'yellow-2',
  totalBuildsAbortedRolling: 'yellow-2',
  totalBuildsFailed: 'red-2',
  totalBuildsSuccess: 'green-2',
  totalTime: 'gray-6',
  totalTimeAbortManual: 'yellow-2',
  totalTimeAbortRolling: 'yellow-2',
  totalTimeFail: 'red-2',
  totalTimeSuccess: 'green-2',
  totalTimeWait: 'gray-6',
};

export const BUILD_METRIC_COLORS_HEX: Record<keyof BuildMetrics, string> = {
  maxTimeAbortManual: variables.colorYellow2,
  maxTimeAbortRolling: variables.colorYellow2,
  maxTimeFail: variables.colorRed2,
  maxTimeSuccess: variables.colorGreen2,
  maxTimeWait: variables.colorGray6,
  totalBuilds: variables.colorGray6,
  totalBuildsAbortedManual: variables.colorYellow2,
  totalBuildsAbortedRolling: variables.colorYellow2,
  totalBuildsFailed: variables.colorRed2,
  totalBuildsSuccess: variables.colorGreen2,
  totalTime: variables.colorGray6,
  totalTimeAbortManual: variables.colorYellow2,
  totalTimeAbortRolling: variables.colorYellow2,
  totalTimeFail: variables.colorRed2,
  totalTimeSuccess: variables.colorGreen2,
  totalTimeWait: variables.colorGray6,
};

export const BUILD_METRIC_NAMES: Record<keyof BuildMetrics, string> = {
  maxTimeAbortManual: 'Aborted',
  maxTimeAbortRolling: 'Aborted',
  maxTimeFail: 'Failed',
  maxTimeSuccess: 'Successful',
  maxTimeWait: 'Wait',
  totalBuilds: 'Total',
  totalBuildsAbortedManual: 'Aborted',
  totalBuildsAbortedRolling: 'Aborted',
  totalBuildsFailed: 'Failed',
  totalBuildsSuccess: 'Successful',
  totalTime: 'Total',
  totalTimeAbortManual: 'Aborted',
  totalTimeAbortRolling: 'Aborted',
  totalTimeFail: 'Failed',
  totalTimeSuccess: 'Successful',
  totalTimeWait: 'Wait',
};
